import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import {
    getFaqLink,
    getLocaleSafely,
    LinkExternal,
    VerificationService,
} from '@sheerid/jslib';

interface Props {
    verificationService: VerificationService;
    isCentered?: boolean; // eslint-disable-line
}

const PoweredByComponent = ({ verificationService, isCentered }: Props) => {
    const { segment } = verificationService.verificationResponse;
    const { programId, programTheme } = verificationService;

    const faqHref = getFaqLink(programTheme, segment, programId, getLocaleSafely(verificationService.viewModel));

    return (
        <div className={isCentered ? 'sid-footer__powered-by-container--stacked sid-l-horz-center' : 'sid-footer__powered-by-container'}>
            <div className={isCentered ? 'sid-footer__powered-by--stacked sid-l-horz-center' : 'sid-footer__powered-by'}>
                <FormattedHTMLMessage
                    id="poweredBy"
                    defaultMessage="Verification services powered by SheerID. "
                />
            </div>
            <div className={isCentered ? 'sid-l-space-top-sm' : ''}>
                <LinkExternal className="sid-faq sid-link" href={faqHref}>
                    <FormattedHTMLMessage id="sheeridFaqs" defaultMessage="SheerID FAQs" />
                </LinkExternal>
            </div>
        </div>
    );
};

export { PoweredByComponent };
